module.exports = __webpack_public_path__ + "static/img/2_b_cross.72b70f38.png";